//
//
//
//
//
//
//
//
//
//
//
//
//

import Role from './tabs/role.vue';
import PermissionPackage from './tabs/permission-package.vue';
export default {
  components: {
    Role,
    PermissionPackage,
  },
  data() {
    return {
      tab: '1',
    };
  },
  methods: {},
};
